import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { GlobalService } from '../../../../services/global.service'

@Component({
    selector: 'app-redefine-contact',
    templateUrl: './redefine-contact.component.html',
    styleUrls: ['./redefine-contact.component.scss'],
})
export class RedefineContactComponent implements OnInit {
    contactForm: FormGroup
    submitting = false
    submitted = false
    error = ''

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public globalService: GlobalService
    ) {
        this.contactForm = this.fb.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            phone: [''],
            company: [''],
            message: ['', [Validators.required]],
        })
    }

    ngOnInit(): void {}

    viewAllProperties(): void {
        // No query param needed - map page detects enterprise from domain
        this.router.navigate(['/map-search'])
    }

    async onSubmit(): Promise<void> {
        if (this.contactForm.invalid) {
            return
        }

        this.submitting = true
        this.error = ''

        try {
            // TODO: Integrate with backend email/enquiry system
            // For now, simulate submission
            await new Promise(resolve => setTimeout(resolve, 1000))
            
            this.submitted = true
            this.contactForm.reset()
        } catch (err) {
            this.error = 'Something went wrong. Please try again or email us directly.'
        } finally {
            this.submitting = false
        }
    }
}

